import axios from 'axios';
import store from '../index';
import VueLodash from 'vue-lodash';
import lodash from 'lodash';
const state = {
	items: [
		{
			_entity: '',
			_item: '',
			code: '',
			conditionType: '',
			country: '',
			createdDate: '',
			currency: '',
			ean: '',
			image: '',
			item: '',
			lastUpdatedDate: '',
			marketplace: '',
			operation: '',
			platform: '',
			price: 0,
			productType: '',
			qt: 0,
			qtunit: 1,
			sellerCurrency: '',
			sellerPrice: 0,
			sellerQt: 0,
			sellerSku: '',
			sku: '',
			status: '',
			url: '',
		},
	],
	item: [],
	index: '',
	sortBy: '',
	sortDesc: '',
};

const getters = {
	getItems: state => {
		return state.items;
	},
	getItem: state => {
		return state.item;
	},
	getIndex: state => {
		return state.index;
	},
	getSortBy: state => {
		return state.sortBy;
	},
	getSortDesc: state => {
		return state.sortDesc;
	},
};

const actions = {
	asyncFetchData: async (context, settings) => {
		const { sortBy, sortDesc, page, itemsPerPage } = settings.options;
		let url = 'items/amazon';

		context.commit('setSortDesc', sortDesc[0]);
		context.commit('setSortBy', sortBy[0]);

		//console.log(context.rootGetters['categories/getSortBy'])
		try {
			var res = await axios.post(
				`${context.rootGetters['settings/getUrl']}${url}`,
				{
					data: {
						sortBy: context.rootGetters['amazon/getSortBy'],
						sortDesc: context.rootGetters['amazon/getSortDesc'],
						page: page,
						itemsPerPage: itemsPerPage,
						filters: settings.filters ? settings.filters : '',
						search: settings.search,
					},
				},
				{
					headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
					'Content-Type': 'application/json',
				},
			);
			await context.commit('setItems', res.data.data);
			return res.data.pagination;
		} catch (err) {
			console.log('errore', err);
			console.log('message', err.message);
			console.log('stack', err.stack);
		}
	},
	updateData: async (context, settings) => {
		let url = 'items/amazon';

		//console.log(context.rootGetters['categories/getSortBy'])
		try {
			var res = await axios.put(
				`${context.rootGetters['settings/getUrl']}${url}`,
				{
					data: {
						...settings,
					},
				},
				{
					headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
					'Content-Type': 'application/json',
				},
			);

			return res.data;
		} catch (err) {
			console.log('errore', err);
			console.log('message', err.message);
			console.log('stack', err.stack);
		}
	},
	asyncSearchData: async (context, settings) => {
		const { sortBy, sortDesc, page, itemsPerPage } = settings.options;
		let url = 'items/amazon';

		context.commit('setSortDesc', sortDesc[0]);
		context.commit('setSortBy', sortBy[0]);
		//console.log(context.rootGetters['categories/getSortBy'])
		return await axios
			.post(
				`${context.rootGetters['settings/getUrl']}${url}`,
				{
					data: {
						sortBy: context.rootGetters['items/getSortBy'],
						sortDesc: context.rootGetters['items/getSortDesc'],
						page: page,
						itemsPerPage: itemsPerPage,
						filters: settings.filters ? settings.filters : '',
						search: settings.search,
					},
				},
				{
					headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
					'Content-Type': 'application/json',
				},
			)

			.then(res => {
				return res.data.data;

				//resolve(res);
			})
			.catch(err => {
				console.log('errore', err);
				/*if (err.response.status === 401) {

                    //this.setLogout();
                    context.commit('profile/setLogout', {}, {root: true})
                    this.$router.push('/login')
                }
                throw Error(err.response.status + ":Posts Not Found");*/
			});
	},

	deleteItems: async (context, settings) => {
		let url = 'items/delete';
		//console.log(context.rootGetters['categories/getSortBy'])
		return await axios
			.post(
				`${context.rootGetters['settings/getUrl']}${url}`,
				{
					data: {
						query: settings,
					},
				},
				{
					headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
					'Content-Type': 'application/json',
				},
			)
			.then(res => {
				//console.log(res.data.pagination);
				//context.commit('setCategories', res.data.data);
				return res.data;
				//resolve(res);
			})
			.catch(err => {
				console.log('errore', err?.response?.status);
				/*if (err.response.status === 401) {

                    //this.setLogout();
                    context.commit('profile/setLogout', {}, {root: true})
                    this.$router.push('/login')
                }*/
				return { error: err?.response?.status || err?.message || 'network_error' };
				//throw Error(err.response.status);
			});
	},

	destroyData: context => {
		context.commit('setItems', []);
		context.commit('setItem', []);
		context.commit('setIndex', '');
	},
	debugListingItems: async (context, payload) => {
		let url = 'amazoneuwest1/debug/ListingItems';
		return await axios.post(`${context.rootGetters['settings/getUrl']}${url}`, payload, {
			headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
			'Content-Type': 'application/json',
		});
	},
	patchListingItems: async (context, payload) => {
		let url = 'amazoneuwest1/patch/ListingItems';
		return await axios.post(`${context.rootGetters['settings/getUrl']}${url}`, payload, {
			headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
			'Content-Type': 'application/json',
		});
	},
	deleteListingItems: async (context, payload) => {
		let url = 'amazoneuwest1/delete/ListingItems';
		return await axios.post(`${context.rootGetters['settings/getUrl']}${url}`, payload, {
			headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
			'Content-Type': 'application/json',
		});
	},
	searchdefinitionsproducttypes: async (context, payload) => {
		let url = 'amazoneuwest1/find/searchdefinitionsproducttypes';

		return await axios.post(
			`${context.rootGetters['settings/getUrl']}${url}`,
			{ ...payload },
			{
				headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
				'Content-Type': 'application/json',
			},
		);
	},
	createListingItems: async (context, payload) => {
		let url = 'amazoneuwest1/create/ListingItems';
		return await axios.post(`${context.rootGetters['settings/getUrl']}${url}`, payload, {
			headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
			'Content-Type': 'application/json',
		});
	},
	getproducttypes: async (context, payload) => {
		let url = 'amazoneuwest1/find/getproducttypes';
		return await axios.post(`${context.rootGetters['settings/getUrl']}${url}`, payload, {
			headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
			'Content-Type': 'application/json',
		});
	},
	searchProducts: async (context, payload) => {
		let url = 'items';

		return await axios
			.post(
				`${context.rootGetters['settings/getUrl']}${url}`,
				{
					data: {
						sortBy: payload.settings.sortBy,
						sortDesc: payload.settings.sortDesc,
						page: payload.settings.page,
						itemsPerPage: payload.settings.itemsPerPage,
						filters: payload.settings.filters ? payload.settings.filters : '',
						search: payload.settings.search,
					},
				},
				{
					headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
					'Content-Type': 'application/json',
				},
			)

			.then(res => {
				return res.data.data;
			})
			.catch(err => {
				console.log('errore', err);
			});
	},
};

const mutations = {
	setItems: async (state, value) => {
		state.items = value;
	},
	setItem: (state, value) => {
		state.item = value;
	},
	setSortBy: (state, value) => {
		state.sortBy = value;
	},
	setIndex: (state, value) => {
		state.index = value;
	},
	setSortDesc: (state, value) => {
		state.sortDesc = value;
	},
};

export default {
	namespaced: true,
	state,
	mutations,
	getters,
	actions,
};
